<template>
  <div class="listScroll" ref="box" @mouseover="setEvet" @mouseout="handelTouchStart" >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "listScroll",
  created() {},
  mounted() {
    this.start(150);
    this.setEvet();
  },
  props: {
    speed: {
      default: 1,
      type: Number,
    },
   num: {
      default: 0,
      type: Number,
    },
  },
  computed: {
    ele0() {
      return this.$refs.box.children[0];
    },
    boxHeight() {
      return this.$refs.box.children[0].children[0].clientWidth;
    },
  },
  data() {
    return {
      width: 0,
      isScroll: true,
      startX:'',
      startY:''
    };
  },
  methods: {
    handelTouchStart(){

    },
    setEvet() {
      this.$refs.box.onmouseenter = () => {
        this.isScroll = false;
        this.height = 0;
      };
      this.$refs.box.onmouseleave = () => {
        this.isScroll = true;
        this.$nextTick(() => {
          this.start(this.height);
        });
      };
    },
    //滚动方法
    start(w) {
      let h = this.boxHeight
      if(h<=0){
        h = 130
      }
      let width = h*this.num
      this.ele0.style = `transform:translateX(-${w}px);width:${width}px`;
      if (w >= this.ele0.clientWidth || w == width-1400) {
        this.width = 0;
      } else {
        this.width += this.speed;
      }
      if (!this.isScroll) return;
      window.requestAnimationFrame(() => {
        this.start(this.width);
      });
    },
  },
};
</script>

<style >
.listScroll {
  overflow: hidden;
}
.hover {
  overflow-x: auto;
}
.hide {
  display: none;
}
</style>